export const validGroupUrl = (platform, value) => {
    try {
        const url = new URL(value)
        const hosts = platform === 'whatsapp' ? ['chat.whatsapp.com', 'web.whatsapp.com'] : platform === 'telegram' ? ['t.me', 'telegram.me', 'web.telegram.org'] : []
        return url.protocol === 'https:' && !url.username && !url.password && hosts.includes(url.hostname) ? url.href : ''
    } catch (_) { return '' }
}
export const publicJobUrl = value => {
    if (!value?.trim()) return ''
    try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password ? url.href : '' } catch (_) { return '' }
}
export const telegramShareUrl = (url, text) => publicJobUrl(url) ? `https://t.me/share/url?url=${encodeURIComponent(publicJobUrl(url))}&text=${encodeURIComponent(text)}` : ''
